// src/index.tsx (or src/index.js)

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalProvider } from './contexts/GlobalContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement // Add type assertion for TS
);
root.render(
  <React.StrictMode>
    <GlobalProvider>
      <App />
    </GlobalProvider>
  </React.StrictMode>
);
